/**
 * The timezone the user is currently in. The value of this property should
 * match a timezone provided in https://www.iana.org/time-zones.
 *
 * @see https://github.com/matrix-org/matrix-spec-proposals/blob/clokep/profile-tz/proposals/4175-profile-field-time-zone.md
 * @experimental
 */
export const ProfileKeyMSC4175Timezone = "us.cloke.msc4175.tz";
